<template>
  <div class="z-10 absolute flex flex-col flex-shrink pin-r pin-t mt-12 mr-6 bg-grey-lightest rounded overflow-y-auto" 
  style="width: 400px; max-height: 450px; box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);">
  <div v-if="notifications && notifications.length<1" class="px-4 py-6 bg-grey-extralight"><div class="text-m text-grey-darkest mr-auto">No notification available</div></div>
    <div v-for="(n, i) in notifications" :key="i" @click="onNotificationClick(n)" class="flex flex-row px-4 py-6 border-b border-solid border-grey-lightest hover:bg-blue-lightest cursor-pointer flex-no-shrink flex-no-grow" v-bind:class="[n.is_read ? 'bg-white' : 'bg-grey-extralight']">
      <div class="flex flex-col text-m text-grey-darkest mr-auto">
        {{n.description}}
        <div class="text-xs text-grey mt-2">
          {{n.time}}
        </div>
      </div>
      <div v-if="n.required_action" class="flex text-blue font-semibold text-xs justify-end" @click="requiredAction(n)" style="text-transform: uppercase; width: 200px">
        {{n.required_action}}
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      notifications: 'notification/getNotifications',
      requests: 'consultationRequest/getRequests'
    })
  },
  methods: {
    onNotificationClick: function (n) {
      this.$store.dispatch('notification/UpdateRead', n.id)
      if (n.title === 'Appointments Scheduled for Today') {
        this.$store.dispatch('configuration/setActiveMiniMenu', 'Appointments')
        this.$store.dispatch('appointmentRequest/updateActiveTab', 'scheduled')
      } else if (n.title === 'Appointment Requested') {
        this.$store.dispatch('configuration/setActiveMiniMenu', 'Appointments')
        this.$store.dispatch('appointmentRequest/updateActiveTab', 'requested')
      } else if (n.title === 'Appointment Scheduled') {
        this.$store.dispatch('configuration/setActiveMiniMenu', 'Appointments')
        this.$store.dispatch('appointmentRequest/updateActiveTab', 'scheduled')
      }
    },
    requiredAction: function (n) {
      if (n.required_action === 'Respond Back') {
        let req = this.requests.find(function (ele) {
          return (ele.consultationRequestId === n.request_id)
        })
        if (req) this.acceptQuery(req)
        this.$emit('enquireNow')
        this.$store.dispatch('configuration/setActiveMiniMenu', 'Chat')
      } else if (n.required_action === 'Enquire Now') {
        this.$emit('enquireNow')
        this.$store.dispatch('configuration/setActiveMiniMenu', 'OfflineConsults')
        this.$store.dispatch('configuration/setOfflineActiveSection', 'connected')
        this.$store.dispatch('offlineConsultation/addEnquireNowConsult', n)
      }
    },
    acceptQuery: function (request) {
      this.$store.dispatch('consultationRequest/acceptQueriedConsultationRequest', request)
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Notification/DoctorNotification.vue